import { render, staticRenderFns } from "./end2.vue?vue&type=template&id=79b5d3bd&scoped=true"
import script from "./end2.vue?vue&type=script&lang=js"
export * from "./end2.vue?vue&type=script&lang=js"
import style0 from "./end2.vue?vue&type=style&index=0&id=79b5d3bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b5d3bd",
  null
  
)

export default component.exports